export default __webpack_public_path__ + "static/media/comingsoon.38fea4ab.jpg";